import { ReplyOrder } from '@diritto/common/reply/constants';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RelayReplyApi } from 'api/ApiHelper';
import { repliesQueryKey } from 'queries/reply/queryKey';
import { RepliesRelayResponseDto } from '@diritto/common/relay/dtos/reply-relay.dtos';

const DEFAULT_LIMIT = 20;

const getNextPageParam = (lastGroup: RepliesRelayResponseDto, allGroups: RepliesRelayResponseDto[]) => {
  if ((lastGroup.replies?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.replies.length, 0);
};

export const useGetRelayProfileRepliesInfiniteQuery = (profileId: number, orderBy: ReplyOrder) =>
  useInfiniteQuery({
    queryKey: repliesQueryKey.profileReplyList(profileId, orderBy),
    queryFn: ({ pageParam = 0 }) =>
      RelayReplyApi.getProfileReplies(profileId, orderBy, { offset: pageParam, limit: DEFAULT_LIMIT }),
    initialPageParam: 0,
    getNextPageParam,
  });
